export default __webpack_public_path__ + "static/media/precisestrikes.d41c9013.png";